export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100]
export const PAGE_SIZE_SEARCH_PARAM = "ps"

const STORAGE_KEY_PREFIX = "smartsetter.client-portal.page-size.v1"

export function coercePageSize(value) {
  const size = Number(value)
  return PAGE_SIZE_OPTIONS.includes(size) ? size : null
}

export function crmPageSizeStorageKey(userId, accountId) {
  if (userId == null || userId === "") {
    return null
  }
  return `${STORAGE_KEY_PREFIX}:${userId}:${accountId ?? userId}`
}

export function readCrmPageSize(storage, key) {
  if (!storage || !key) {
    return null
  }
  try {
    return coercePageSize(storage.getItem(key))
  } catch (_) {
    return null
  }
}

export function writeCrmPageSize(storage, key, pageSize) {
  const size = coercePageSize(pageSize)
  if (!storage || !key || size == null) {
    return
  }
  try {
    storage.setItem(key, String(size))
  } catch (_) {
    // Private mode / quota — pagination still works for this visit.
  }
}

export function resolveCrmPageSize({ storedValue, urlValue, defaultPageSize }) {
  return (
    coercePageSize(storedValue) ??
    coercePageSize(urlValue) ??
    coercePageSize(defaultPageSize) ??
    PAGE_SIZE_OPTIONS[1]
  )
}
